module.exports = "/images/picture-report-red.svg?f625a45d736e212ad9ecb81b966bde00";